// extracted by mini-css-extract-plugin
export default {"root":"SingleAlert_root__DwOXc","severity":"SingleAlert_severity__OrLCg","low":"SingleAlert_low__GRiyC"};